__turbopack_context__.v({
  "get-signature-button-container": "OnboardingPreviewPageForMobile-module-scss-module__1WA79W__get-signature-button-container",
  "introduction-header": "OnboardingPreviewPageForMobile-module-scss-module__1WA79W__introduction-header",
  "introduction-subtext": "OnboardingPreviewPageForMobile-module-scss-module__1WA79W__introduction-subtext",
  "preview-container": "OnboardingPreviewPageForMobile-module-scss-module__1WA79W__preview-container",
  "preview-section": "OnboardingPreviewPageForMobile-module-scss-module__1WA79W__preview-section",
  "preview-wrapper": "OnboardingPreviewPageForMobile-module-scss-module__1WA79W__preview-wrapper",
});
